/**
 * 커뮤니티 금칙어 필터 (App Store 가이드라인 1.2 — 불쾌한 콘텐츠가 게시되기 전에 거른다, 2026-09-29).
 * 서버가 글 제목·본문·투표 제목·선택지·댓글을 저장하기 전에 검사하고(걸리면 400), 앱도 보내기 전에 같은 함수로 먼저 막는다.
 *
 * 목록은 욕설·혐오 비하어·성적 표현만 좁게 담는다. 음식 앱이라 오탐이 잦은 말은 일부러 뺐다
 * (보지 마세요·자지 마·새끼 돼지·엿, 妈妈的·玉米棒子·几把刀·去死皮, 天かす·クズ野菜·ブスケッタ,
 * retard the dough·spotted dick·pussy cat·cock-a-leekie 등). 걸러지지 않은 것은 신고·차단과 운영자 삭제로 처리한다.
 */

/** 서버가 금칙어로 거절할 때의 오류 메시지. 앱은 이 값으로 4개 언어 안내를 고른다 */
export const OBJECTIONABLE_CONTENT_MESSAGE =
  'This contains words that aren’t allowed in the community. Edit it and try again.'

/** 운영자가 커뮤니티 이용을 제한한 계정이 글·댓글을 쓰려 할 때 (403) */
export const COMMUNITY_RESTRICTED_MESSAGE =
  'Your account can no longer post in the community because of reported content.'

/**
 * 영어 — 단어 경계로만 맞춘다 (cucumber 의 cum, Scunthorpe 의 cunt, sniggered 같은 오탐 방지). 정규식 조각.
 * shiitake·shitake 는 shit 뒤에 글자가 이어져 걸리지 않는다
 */
const LATIN_TERMS = [
  '\\w*fuck\\w*',
  'shits?',
  'shitty',
  'shithead',
  'shithole',
  'bullshit',
  'horseshit',
  'dipshit',
  'bitch(?:es|y)?',
  'sonofabitch',
  'cunts?',
  'assholes?',
  'arseholes?',
  'dickheads?',
  'wank\\w*',
  'twats?',
  'whores?',
  'sluts?',
  'slutty',
  'porn\\w*',
  'cum',
  'cumshots?',
  'blowjobs?',
  'handjobs?',
  'dildos?',
  'hentai',
  'nudes',
  'milfs?',
  'nigg(?:er|a|az)s?',
  'faggots?',
  'kikes?',
  'spics?',
  'gooks?',
  'wetbacks?',
  'rape[ds]?',
  'raping',
  'rapists?',
  'kys',
  'kill (?:yo)?urself',
]

/** 한국어·일본어·중국어 — 띄어쓰기가 없어 부분 일치. 정규식 조각 (앞뒤 예외는 lookahead 나 SAFE_PHRASES 로) */
const CJK_TERMS = [
  // 한국어
  '씨발',
  '씨빨',
  '씨팔',
  '시발놈',
  '시발년',
  '시발새끼',
  'ㅅㅂ',
  'ㅆㅂ',
  'ㅄ',
  '병신',
  '븅신',
  '좆',
  '지랄',
  '개새끼',
  '개새기',
  '개색기',
  '개색끼',
  '개새꺄',
  '씹새',
  '씹년',
  '씹할',
  '씹창',
  '미친년',
  '미친놈',
  '미친새끼',
  '니애미',
  '느금마',
  '애미뒤진',
  '애비뒤진',
  '창녀',
  '걸레년',
  '섹스',
  '야동',
  '강간',
  '한남충',
  '김치녀',
  '된장녀',
  '틀딱',
  '짱깨',
  '짱개',
  '쪽바리',
  '똥남아',
  // 일본어 (死ねる = "죽을 만큼 맛있다" 같은 칭찬은 통과. レイプ·チンコ·マンコ·気違い·氏ね 는
  // プレイプラン·キッチンコンロ·ヒューマンコメディ·雰囲気違い·田中氏ね 를 걸어서 뺐다. 강간은 아래 強姦 으로)
  '死ね(?!る)',
  '殺すぞ',
  'ぶっ殺',
  'ぶっころ',
  'キチガイ',
  '基地外',
  'ガイジ(?!ン)',
  'おまんこ',
  'オマンコ',
  'ちんぽ',
  'チンポ',
  'セックス',
  'セフレ',
  '売春',
  '淫乱',
  '肉便器',
  'ヤリマン',
  'ヤリチン',
  'ニガー',
  'チョン公',
  'シナ人',
  'ファック',
  'くたばれ',
  // 중국어 (간체·번체). 他妈的·你妈的(엄마가 만든 요리)·做爱(做爱心便当)·鸡巴(炸鸡巴适)·草你妈(香草你妈妈) 는 오탐이라 뺐다
  '操你',
  '肏',
  '草泥马',
  '傻逼',
  '傻屄',
  '煞笔',
  '傻b',
  '你妈逼',
  '妈了个逼',
  '媽了個逼',
  '婊子',
  '贱人',
  '賤人',
  '贱货',
  '賤貨',
  '屌你',
  '狗日的',
  '王八蛋',
  '去死吧',
  '你去死',
  '强奸',
  '強姦',
  '卖淫',
  '賣淫',
  '黑鬼',
  '尼哥',
  '日本鬼子',
  '支那猪',
  '台巴子',
  '脑残',
  '腦殘',
  '幹你娘',
  '干你娘',
]

/** 금칙어를 품고 있지만 멀쩡한 말 — 검사 전에 지운다 (질병신고·생강간장·food porn) */
const SAFE_PHRASES = ['질병신', '생강간', 'food porn']

/** 흔한 숫자·기호 치환 (sh1t·$hit·b1tch). ! 는 바꾸지 않는다 — 문장 끝 "shit!" 이 shiti 가 되어 놓친다 */
const LEET: Record<string, string> = {
  '0': 'o',
  '1': 'i',
  '3': 'e',
  '4': 'a',
  '5': 's',
  '7': 't',
  '@': 'a',
  $: 's',
}

/** 전각·호환 문자 → 기본 문자(NFKC), 소문자, 보이지 않는 문자 제거, 공백은 하나로 */
function normalize(text: string): string {
  let out = text
    .normalize('NFKC')
    .toLowerCase()
    .replace(/[\u00AD\u200B-\u200D\u2060\uFEFF]/g, '')
    .replace(/\s+/g, ' ')
  for (const safe of SAFE_PHRASES) out = out.split(normalize0(safe)).join(' ')
  return out
}

/** SAFE_PHRASES 정규화 (normalize 가 자기 자신을 부르지 않게 분리) */
function normalize0(text: string): string {
  return text.normalize('NFKC').toLowerCase()
}

// 목록도 같은 방식으로 정규화해 둔다 (ㅅㅂ 같은 호환 자모는 NFKC 에서 모양이 바뀐다)
const LATIN_RE = new RegExp(`(?:^|[^a-z0-9])(?:${LATIN_TERMS.join('|')})(?![a-z0-9])`)
const CJK_RE = new RegExp(CJK_TERMS.map(normalize0).join('|'), 'u')

/** 글자 사이 기호를 뺀 모양 (씨.발, 傻-逼). 공백은 남긴다 — "우유 한 병 신선하게" 가 병신이 되지 않게 */
function squeeze(text: string): string {
  return text.replace(/[\p{P}\p{S}]/gu, '')
}

function leet(text: string): string {
  return text.replace(/[013457@$]/g, (ch) => LEET[ch] ?? ch)
}

/** 금칙어가 들어 있으면 true. 빈 값은 false */
export function containsObjectionable(text: string | null | undefined): boolean {
  if (!text) return false
  const plain = normalize(text)
  if (LATIN_RE.test(plain) || LATIN_RE.test(leet(plain))) return true
  return CJK_RE.test(plain) || CJK_RE.test(squeeze(plain))
}

/** 여러 칸 중 하나라도 걸리면 true (제목·본문·투표 선택지를 한 번에) */
export function anyObjectionable(texts: readonly (string | null | undefined)[]): boolean {
  return texts.some((t) => containsObjectionable(t))
}
